import { Box, Typography, Button } from "@mui/material";

const MaintenancePage = () => {
  const handleRetry = () => window.location.reload();

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        backgroundColor: "#f9f9f9",
      }}
    >
      <Typography variant="h4" gutterBottom>
        🚧 Server Under Maintenance
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 400 }}>
        Our servers are temporarily unavailable. Please check back soon.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={handleRetry}
        sx={{ mt: 3 }}
      >
        Retry
      </Button>
    </Box>
  );
};

export default MaintenancePage;
